import { useState, useEffect, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  Button,
  Drawer,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseAdvContract } from "./UseAdvContract";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import { removeComma, toMoney } from "../../util/Utils";
import { useSnackbar } from "notistack";
import TariffsAutoComplete from "../advertisments/TariffsAutoComplete";
import AdvertismentsAutoComplete from "../advertisments/AdvertismentsAutoComplete";

export default function ItemsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { addAdvContractItems, deleteAdvContractItems, getAdvContractByID } =
    UseAdvContract();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const addTitle = useRef(null);
  const [pageState, setPageState] = useState({
    page: 1,
  });

  const [itemRes, setItemRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [tariffState, setTariffState] = useState({
    id: undefined,
    contractId: undefined,
    row: undefined,
    cost: undefined,
    title: undefined,
    counter: 1,
    time: undefined,
    advertismentID: undefined,
    tariffID: undefined,
  });

  useEffect(() => {
    if (props.contractId) {
      getAdvContractByID(props.contractId, (resault) => {
        setItemRes(resault.items);
      });
    }
  }, [props.contractId]);

  useEffect(() => {
    if (itemRes) {
      var lastrow = Math.max.apply(
        Math,
        itemRes &&
          itemRes.map(function (o) {
            if (o) {
              return o.row;
            } else {
              return 1;
            }
          })
      );
      setTariffState({
        ...tariffState,
        contractId: props.contractId,
        row: lastrow != -Infinity ? lastrow + 1 : 1,
      });
    }
  }, [itemRes]);

  const newFunc = () => {
    setOpen(true);
    setTariffState({
      ...tariffState,
      id: undefined,
      cost: undefined,
      title: undefined,
      counter: 1,
      time: undefined,
      advertismentID: undefined,
      tariffID: undefined,
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "row",
      headerName: "ردیف",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 200,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "time",
      headerName: "مدت زمان",
      width: 170,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "counter",
      headerName: "تعداد",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.counter ? toMoney(cellValues.row.counter) : 0}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "قیمت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography>
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 120,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="Delete">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setOpen(true);
                  setTariffState({
                    id: cellValues.row.id,
                    contractId: props.contractId,
                    row: cellValues.row.row,
                    cost: cellValues.row.cost,
                    title: cellValues.row.title,
                    counter: cellValues.row.counter,
                    time: cellValues.row.time,
                    advertismentID: cellValues.row.advertismentID,
                    tariffID: cellValues.row.tariffID,
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      {itemRes ? (
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={itemRes}
          page={pageState.page - 1}
          pageSize={100}
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={itemRes && itemRes.length ? itemRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              PrintAdverContract: true,
              contractId: props.contractId,
              // PrintAdverContract: PrintAdverContract,
              rowCount: itemRes && itemRes.length ? itemRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "ID",
                  sort: "Asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"آیتم"}
        callback={() => {
          setProgress(true);
          deleteAdvContractItems(deleteState.id, () => {
            getAdvContractByID(tariffState.contractId, (resault) => {
              setItemRes(resault.items);
            });
          });
        }}
      ></DeleteRow>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
          setTariffState({
            ...tariffState,
            cost: undefined,
            title: undefined,
            counter: 1,
            time: undefined,
            advertismentID: undefined,
            tariffID: undefined,
          });
        }}
        sx={{
          "&  .MuiDrawer-paper": {
            height: "40%",
            width: isSmall ? "90%" : "40%",
            mx: "auto",
            borderRadius: 3,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          sx={{
            display: "flex",
            // alignItems: "center",
            flexDirection: "column",
            gap: 4,
            m: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <AdvertismentsAutoComplete
              selectedAdvertismentID={tariffState.advertismentID}
              contract={true}
              state={tariffState}
              setState={setTariffState}
            />
            <TariffsAutoComplete
              contract={true}
              selectedTariffID={tariffState.tariffID}
              advertismentID={
                tariffState.advertismentID
                  ? tariffState.advertismentID
                  : undefined
              }
              state={tariffState}
              setState={setTariffState}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              color="secondary"
              id="outlined-multiline-static"
              label="عنوان"
              autoFocus
              fullWidth
              value={tariffState.title ? tariffState.title : ""}
              onChange={(event) => {
                setTariffState({
                  ...tariffState,
                  title: event.target.value,
                });
              }}
            />
            <TextField
              color="secondary"
              id="outlined-multiline-static"
              label="مدت زمان"
              fullWidth
              value={tariffState.time ? tariffState.time : ""}
              onChange={(event) => {
                setTariffState({
                  ...tariffState,
                  time: event.target.value,
                });
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <TextField
              color="secondary"
              id="outlined-multiline-static"
              label="تعداد"
              fullWidth
              value={tariffState.counter ? toMoney(tariffState.counter) : ""}
              onChange={(event) => {
                setTariffState({
                  ...tariffState,
                  counter: removeComma(event.target.value),
                });
              }}
              sx={{
                width: "20%",
                input: {
                  textAlign: "center",
                },
              }}
            />
            <TextField
              color="secondary"
              id="outlined-multiline-static"
              label="قیمت"
              fullWidth
              value={tariffState.cost ? toMoney(tariffState.cost) : ""}
              onChange={(event) => {
                setTariffState({
                  ...tariffState,
                  cost: removeComma(event.target.value),
                });
              }}
              sx={{
                width: "30%",
                input: {
                  textAlign: "center",
                },
              }}
            />
          </Box>
          <Box sx={{ mx: "auto", mb: 3 }}>
            <Button
              variant="contained"
              sx={{ width: "100px", mr: 2 }}
              color="secondary"
              onClick={() => {
                if (
                  !tariffState.title ||
                  !tariffState.cost ||
                  !tariffState.time ||
                  !tariffState.counter ||
                  !tariffState.advertismentID ||
                  !tariffState.tariffID
                ) {
                  enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                }
                setProgress(true);
                addAdvContractItems(tariffState, () => {
                  getAdvContractByID(props.contractId, (resault) => {
                    setItemRes(resault.items);
                    setOpen(false);
                    props.callback(props.contractId);
                    setTariffState({
                      ...tariffState,
                      cost: undefined,
                      title: undefined,
                      counter: 1,
                      time: undefined,
                      advertismentID: undefined,
                      tariffID: undefined,
                    });
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              sx={{ width: "100px" }}
              color="secondary"
              onClick={() => {
                setTariffState({
                  ...tariffState,
                  cost: undefined,
                  title: undefined,
                  counter: 1,
                  time: undefined,
                  advertismentID: undefined,
                  tariffID: undefined,
                });
                setOpen(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
